import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import NibrsServices from '@/CADServices/APIs/nibrs';
import { base64ToString } from '@/Components/Common/Utility';

const NibrsLeftTreeContext = createContext();

export const NibrsProvider = ({ children }) => {
  const location = useLocation();

  const [nibrsLeftTreeErrorsData, setNibrsLeftTreeErrorsData] = useState(null);
  const query = useMemo(() => new URLSearchParams(location.search), [location.search]);
  let IncID = query?.get('IncId');

  if (!IncID) IncID = 0;
  else IncID = parseInt(base64ToString(IncID), 10);

  const getNIBRSLeftTreeErrorsKey = `/NIBRS/GetNIBRSLeftTreeErrors/${IncID}`;
  const {
    data: nibrsLeftTreeErrorsResponse,
    isSuccess: isNibrsLeftTreeErrorsSuccess,
    refetch: refetchNibrsLeftTreeErrors,
  } = useQuery(
    [getNIBRSLeftTreeErrorsKey, { IncidentId: IncID, state: 'TX' }],
    NibrsServices.getNIBRSLeftTreeErrors,
    {
      refetchOnWindowFocus: false,
      enabled: !!IncID,
      retry: 0,
    }
  );

  useEffect(() => {
    if (nibrsLeftTreeErrorsResponse && isNibrsLeftTreeErrorsSuccess) {
      setNibrsLeftTreeErrorsData(nibrsLeftTreeErrorsResponse?.data?.LeftTreeErrors);
    } else {
      setNibrsLeftTreeErrorsData([]);
    }
  }, [nibrsLeftTreeErrorsResponse, isNibrsLeftTreeErrorsSuccess]);

  const value = useMemo(
    () => ({
      nibrsLeftTreeErrorsData,
      refetchNibrsLeftTreeErrors,
    }),
    [nibrsLeftTreeErrorsData, refetchNibrsLeftTreeErrors]
  );

  return <NibrsLeftTreeContext.Provider value={value}>{children}</NibrsLeftTreeContext.Provider>;
};

export const useNibrs = () => {
  const context = useContext(NibrsLeftTreeContext);
  if (!context) {
    throw new Error('useNibrs must be used within a NibrsProvider');
  }
  return context;
};

export default NibrsLeftTreeContext;
